import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

const initialState = {
  loading: false,
  isTransferableData: {},
  error: "",
  success: false,
  status: "",
};

const isTransferableCall = createAsyncThunk(
  "post/isTransferable",
  async (data) => {
    try {
      const result = await axios.post(
        "https://apac.api.capillarytech.com/mobile/v2/api/points/isTransferrable",
        data
      );

      return result?.data;
    } catch (err) {
      console.log(err);
    }
  }
);

const isTransferableSlice = createSlice({
  name: "isTransferable",
  initialState,
  reducers: {
    reset: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
      state.isTransferableData = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(isTransferableCall.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(isTransferableCall.fulfilled, (state, action) => {
     
      state.loading = false;
      state.isTransferableData =
        action?.payload?.hasOwnProperty("data") &&
        action?.payload?.data &&
        action?.payload?.data[0];
      state.success =
        action?.payload?.hasOwnProperty("errors") &&
        action?.payload?.errors?.length > 0
          ? false
          : true;
      state.error =
        action?.payload?.hasOwnProperty("errors") &&
        action?.payload?.errors?.length > 0
          ? action?.payload?.errors[0]?.message
          : "";
    });
    builder.addCase(isTransferableCall.rejected, (state, action) => {
      state.loading = false;
      state.isTransferableData = {};
      state.error = action.error.message;
      state.success = false;
    });
  },
});

export default isTransferableSlice.reducer;
export const { reset } = isTransferableSlice.actions;
export { isTransferableCall };
